import { AppService } from "app/services/app.service";

import { AppFilter } from "app/models/app-filter.model";

export abstract class AbItemAssembleia extends AppService {
  abstract prefixo: string;
  abstract salvarAlterarDados(entity: any);
  abstract getDados(id: any);
  abstract getDadosByAssembleiaId(id: any);
  abstract getOpsVotoByItemIdId(id: any);
  abstract getDadosByFilter(filter: any);
  abstract deleteDados(id: any);
  abstract downloadArquivo(itemId: number, assembleiaId: number, nomeArquivo: string);
  abstract downloadAnexo(assembleiaItemId: string, anexoId: number);
  abstract downloadArquivoItemAssembleiaOpcaoVoto(itemAssembleiaIdOpcaoVoto: number, nomeArquivo: string);
  abstract deleteArquivoItemAssembleiaOpcaoVoto(itemAssembleiaIdOpcaoVoto: number, nomeArquivo: string);
  abstract getItemAssembleiaComFiltro(filter: AppFilter);
}